"use client";

import { isPreviewing, RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import {
  PRODUCTS_BINDING,
  PRODUCTS_BINDING_INPUT,
} from "@/libs/builder/consts";

import { SimpleProductTeaserAuthorView } from "./SimpleProductTeaserAuthorView";

const SimpleProductTeaser = dynamic(
  async () => (await import("./SimpleProductTeaser")).SimpleProductTeaser
);

export const simpleProductTeaserInputs = [
  {
    name: "sku",
    type: "MagentoProduct",
    required: true,
  },
  {
    name: "name",
    friendlyName: "Product name (to override value from magento)",
    type: "string",
    defaultValue: "Ploom X",
  },
  {
    name: "src",
    friendlyName: "Product image (to override value from magento)",
    type: "file",
    allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F8ab4cce049ca4707baa17b5b5d0c95a6",
  },
  {
    name: "link",
    type: "object",
    friendlyName: "Link (to override default value)",
    subFields: [
      { name: "text", type: "string" },
      { name: "href", type: "url" },
    ],
    defaultValue: {
      text: "Shop now",
      href: "",
    },
  },
  PRODUCTS_BINDING_INPUT,
] as const satisfies Inputs;

export const SimpleProductTeaserComponent: RegisteredComponent = {
  name: "SimpleProductTeaser",
  component: isPreviewing()
    ? SimpleProductTeaserAuthorView
    : SimpleProductTeaser,
  inputs: simpleProductTeaserInputs,
  defaults: {
    bindings: PRODUCTS_BINDING,
  },
};
